import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { withBrand } from '../../../../providers/BrandProvider';
import ProductItem from './ProductItem/ProductItem';

import './ProductType.scss';

const SINGLE_CHOICE = 'SINGLE_CHOICE';

export class ProductType extends Component {
  static propTypes = {
    productType: PropTypes.object,
    selected: PropTypes.object,
    tier: PropTypes.object,
    vatRate: PropTypes.number,
    taxLabelStyle: PropTypes.string,
    priceInclVat: PropTypes.bool,
    vatRules: PropTypes.bool,
    onProductChange: PropTypes.func,
    onOptionChange: PropTypes.func,
    brand: PropTypes.object,
  };

  isNoneProductItemDisabled() {
    const { productType, selected } = this.props;

    const siblingProductsIds = Object.keys(
      selected[productType.productTypeId].products,
    ).filter((id) => id !== 'none');

    const disabledProducts = siblingProductsIds
      .map((productId) => {
        return selected[productType.productTypeId].products[productId];
      })
      .filter((productItem) => productItem.disabled);

    return disabledProducts.length === siblingProductsIds.length;
  }

  render() {
    const {
      productType = {},
      selected = {},
      tier,
      vatRate = 0,
      taxLabelStyle = 'VAT',
      vatRules = false,
      priceInclVat = false,
      onProductChange,
      onOptionChange,
      brand: { secondaryColor } = {},
      t,
    } = this.props;

    const noneProductItem = {
      id: 'none',
      productOptionsList: [],
      name: productType.noneLabel || t('event.purchase.single-select.none'),
      disabled:
        productType.selectionType === SINGLE_CHOICE
          ? this.isNoneProductItemDisabled()
          : false,
    };

    return (
      productType.products &&
      productType.products.length > 0 && (
        <div className="c-product-type">
          <h4
            className="c-product-type__heading"
            style={{ color: secondaryColor }}
          >
            {productType.name}
          </h4>
          <div className="c-product-type__body">
            {(productType.products || []).map((productItem) => {
              return (
                <ProductItem
                  key={productItem.id}
                  productType={productType}
                  productItem={productItem}
                  tier={tier}
                  vatRate={vatRate}
                  vatRules={vatRules}
                  taxLabelStyle={taxLabelStyle}
                  isPriceInclVat={priceInclVat}
                  selected={
                    selected[productType.productTypeId].products[productItem.id]
                  }
                  onProductChange={onProductChange}
                  onOptionChange={onOptionChange}
                />
              );
            })}
            {productType.selectionType === SINGLE_CHOICE &&
              selected[productType.productTypeId].products.none && (
                <ProductItem
                  key={noneProductItem.id}
                  productType={productType}
                  productItem={noneProductItem}
                  tier={tier}
                  vatRate={vatRate}
                  taxLabelStyle={taxLabelStyle}
                  isPriceInclVat={priceInclVat}
                  selected={
                    selected[productType.productTypeId].products[
                      noneProductItem.id
                    ]
                  }
                  disabled={noneProductItem.disabled}
                  onProductChange={onProductChange}
                  onOptionChange={onOptionChange}
                />
              )}
          </div>
        </div>
      )
    );
  }
}

export default withTranslation()(withBrand(ProductType));
